export function findMenu(routes, name) {

	let _menu = [];

	let findChild = arr => {
		arr.forEach(item => {
			if (!item.children) return;

			if (item.name == name) _menu = item.children || [];

			item.children.forEach(itm => {
				if (itm.name == name) _menu = itm.children || [];

				if (itm.children) findChild(itm.children);
			});
		});
	}

	findChild(routes);

	return _menu;
}